export default __webpack_public_path__ + "static/media/step-loader.04ea36c6.gif";